// Briefing status pill — colored chip mirrors the legacy demo's pill but
// styled with Tailwind tokens so it matches the rest of the Inku UI.

import { cn } from "@/lib/utils";
import type { BriefingStatus } from "@/lib/types";

const STATUS_META: Record<
  BriefingStatus,
  { label: string; className: string }
> = {
  draft: {
    label: "Draft",
    className: "bg-muted text-muted-foreground border-border",
  },
  in_creative_review: {
    label: "In creative review",
    className: "bg-amber-50 text-amber-900 border-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-900",
  },
  in_business_review: {
    label: "In business review",
    className: "bg-blue-50 text-blue-900 border-blue-200 dark:bg-blue-950/40 dark:text-blue-200 dark:border-blue-900",
  },
  approved: {
    label: "Approved",
    className: "bg-green-50 text-green-900 border-green-200 dark:bg-green-950/40 dark:text-green-200 dark:border-green-900",
  },
  rejected: {
    label: "Rejected",
    className: "bg-red-50 text-red-900 border-red-200 dark:bg-red-950/40 dark:text-red-200 dark:border-red-900",
  },
  archived: {
    label: "Archived",
    className: "bg-muted text-muted-foreground border-border opacity-60",
  },
};

export function StatusPill({
  status,
  size = "md",
}: {
  status: BriefingStatus;
  size?: "sm" | "md";
}) {
  const meta = STATUS_META[status] ?? STATUS_META.draft;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border font-mono uppercase tracking-wider whitespace-nowrap",
        size === "sm" ? "px-2 py-0.5 text-[9px]" : "px-2.5 py-1 text-[10px]",
        meta.className
      )}
    >
      {meta.label}
    </span>
  );
}
